import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { BudgetModelDto, PosteBudgetaireModelDto } from 'src/graphql/generated-types';
import { KalTableComponent } from 'src/app/_shared/modules/kal-table/kal-table.component';
import { KalTableHeader } from 'src/app/_shared/modules/kal-table/classes/kal-table-header';
import { UntypedFormControl } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';

enum PeriodicityEnum {
    Annual = 'annual',
    Monthly = 'monthly'
}

@Component({
    selector: 'app-shared-accounting-budgets-children-list',
    templateUrl: './shared-accounting-budgets-children-list.component.html',
    styleUrls: ['./shared-accounting-budgets-children-list.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAccountingBudgetsChildrenListComponent<T extends BudgetModelDto | PosteBudgetaireModelDto> extends BaseComponent implements OnInit, AfterViewInit {

    @Input()
    list: T[] = [];

    @Input()
    columns: KalTableHeader<T>[];

    @Input()
    annualColumns: (keyof T)[];

    @Input()
    monthlyColumns: (keyof T)[];

    @ViewChild(KalTableComponent) tableRef: KalTableComponent<T>;

    readonly periodicitiesList: { value: PeriodicityEnum, label: string }[] = [
        {value: PeriodicityEnum.Annual, label: 'Annuel'},
        {value: PeriodicityEnum.Monthly, label: 'Mensuel'}
    ];

    displayedColumns: (keyof T)[];

    periodicityControl = new UntypedFormControl(PeriodicityEnum.Annual);

    total(code: keyof T): number {
        return this.list.reduce((acc, element) => {
            return +acc + +element[code];
        }, 0);
    }

    ngOnInit(): void {
        this.displayedColumns = this.annualColumns;
    }

    ngAfterViewInit(): void {
        this.watch$ = this.periodicityControl.valueChanges.pipe(
            tap(periodicity => {
                const columns = `${periodicity}Columns`;
                this.displayedColumns = this[columns];

                this.tableRef.render();
                this.cdr.markForCheck();
            })
        );
    }
}
